/** Defaults to true when the BE value is missing or explicitly null. */
export const getUseStorageSystemEnergySavingMode = (emsPowerSaveEnabled: boolean | null | undefined): boolean => {
  return emsPowerSaveEnabled ?? true
}
